/** Item 11 do lote de 19/10: chat do site (canal Site e o cadastro dos widgets em Conversas > Chat do site), nos três idiomas. */
const pt = {
  site: {
    listaVazia: 'Quando alguém escrever pelo chat de um dos seus sites, a conversa aparece aqui.',
    nome: 'Nome do widget',
    ajudaNome: 'Aparece no topo do chat, para o visitante. Ex.: o nome do site ou da empresa.',
    dominios: 'Domínios do site',
    ajudaDominios: 'Um por linha. O chat só abre nestes endereços: "exemplo.com.br" vale só para ele; "*.exemplo.com.br" vale para os subdomínios (www, loja...).',
    semDominio: 'Sem domínio, o chat não abre em site nenhum.',
    fila: 'Fila',
    filaPadrao: 'A primeira fila ativa do canal Chat do site',
    ajudaFila: 'As conversas deste site entram nesta fila, com o horário, a distribuição e a oportunidade automática dela.',
    cor: 'Cor de destaque',
    cores: { acento: 'Verde Malgo', azul: 'Azul', ciano: 'Ciano', roxo: 'Roxo', laranja: 'Laranja', verde: 'Verde' },
    saudacao: 'Saudação',
    ajudaSaudacao: 'Primeira mensagem que o visitante vê ao abrir o chat.',
    pedirDados: 'Pedir nome e e-mail ou telefone antes de abrir',
    ajudaPedirDados: 'Com os dados, o visitante vira lead no Cadastros (casado pelo e-mail ou telefone). Sem eles, entra como visitante do site.',
    lgpd: 'Texto de aceite (LGPD)',
    ajudaLgpd: 'Com texto, o visitante marca o aceite antes de conversar; o sistema guarda quando e qual texto foi aceito.',
    ativo: 'Widget ativo',
    inativo: 'Inativo',
    novo: 'Novo widget',
    conversasAtivas: 'Conversas ativas',
    codigo: 'Código para incorporar',
    ajudaCodigo: 'Cole antes do </body> das páginas do site. Se o site tiver política de segurança de conteúdo (CSP), libere este endereço em script-src e connect-src.',
    semEndereco: 'O endereço do Sandbox não está configurado no servidor: o chat do Sandbox não abre em site nenhum até a configuração.',
    salveParaCodigo: 'Salve o widget para ver o código.',
    copiar: 'Copiar código',
    copiado: 'Código copiado',
    naoCopiado: 'Não foi possível copiar; selecione o código e copie.',
    vazioTitulo: 'Nenhum chat do site ainda',
    vazio: 'Crie um widget para cada site (ou grupo de sites) e cole o código nas páginas. As conversas chegam na caixa Site, na fila escolhida.',
    removerTitulo: 'Excluir este widget?',
    removerTexto: 'O chat some dos sites na hora. As conversas que já chegaram continuam no Conversas.',
  },
};

type Dic = typeof pt;

const en: Dic = {
  site: {
    listaVazia: 'When someone writes through the chat on one of your websites, the conversation shows up here.',
    nome: 'Widget name',
    ajudaNome: 'Shown at the top of the chat to the visitor. E.g. the website or company name.',
    dominios: 'Website domains',
    ajudaDominios: 'One per line. The chat only opens on these addresses: "example.com" is only that one; "*.example.com" covers its subdomains (www, shop...).',
    semDominio: 'Without a domain, the chat does not open on any website.',
    fila: 'Queue',
    filaPadrao: 'The first active queue of the Website chat channel',
    ajudaFila: 'Conversations from this website enter this queue, with its hours, distribution and automatic opportunity.',
    cor: 'Accent color',
    cores: { acento: 'Malgo green', azul: 'Blue', ciano: 'Cyan', roxo: 'Purple', laranja: 'Orange', verde: 'Green' },
    saudacao: 'Greeting',
    ajudaSaudacao: 'First message the visitor sees when opening the chat.',
    pedirDados: 'Ask for name and email or phone before starting',
    ajudaPedirDados: 'With the details, the visitor becomes a lead in Records (matched by email or phone). Without them, they come in as a website visitor.',
    lgpd: 'Consent text (privacy)',
    ajudaLgpd: 'With a text, the visitor ticks the consent before chatting; the system keeps when and which text was accepted.',
    ativo: 'Widget active',
    inativo: 'Inactive',
    novo: 'New widget',
    conversasAtivas: 'Active conversations',
    codigo: 'Embed code',
    ajudaCodigo: 'Paste it before the </body> of the website pages. If the website has a Content Security Policy (CSP), allow this address in script-src and connect-src.',
    semEndereco: 'The Sandbox address is not configured on the server: the Sandbox chat does not open on any website until it is.',
    salveParaCodigo: 'Save the widget to see the code.',
    copiar: 'Copy code',
    copiado: 'Code copied',
    naoCopiado: 'Could not copy; select the code and copy it.',
    vazioTitulo: 'No website chat yet',
    vazio: 'Create a widget for each website (or group of websites) and paste the code on its pages. Conversations arrive in the Website inbox, in the chosen queue.',
    removerTitulo: 'Delete this widget?',
    removerTexto: 'The chat disappears from the websites right away. Conversations that already arrived stay in Conversations.',
  },
};

const es: Dic = {
  site: {
    listaVazia: 'Cuando alguien escriba por el chat de uno de tus sitios, la conversación aparece aquí.',
    nome: 'Nombre del widget',
    ajudaNome: 'Aparece arriba del chat, para el visitante. Ej.: el nombre del sitio o de la empresa.',
    dominios: 'Dominios del sitio',
    ajudaDominios: 'Uno por línea. El chat solo abre en estas direcciones: "ejemplo.com" vale solo para él; "*.ejemplo.com" vale para los subdominios (www, tienda...).',
    semDominio: 'Sin dominio, el chat no abre en ningún sitio.',
    fila: 'Cola',
    filaPadrao: 'La primera cola activa del canal Chat del sitio',
    ajudaFila: 'Las conversaciones de este sitio entran en esta cola, con su horario, distribución y oportunidad automática.',
    cor: 'Color de destaque',
    cores: { acento: 'Verde Malgo', azul: 'Azul', ciano: 'Cian', roxo: 'Morado', laranja: 'Naranja', verde: 'Verde' },
    saudacao: 'Saludo',
    ajudaSaudacao: 'Primer mensaje que el visitante ve al abrir el chat.',
    pedirDados: 'Pedir nombre y correo o teléfono antes de empezar',
    ajudaPedirDados: 'Con los datos, el visitante se vuelve lead en Registros (por el correo o el teléfono). Sin ellos, entra como visitante del sitio.',
    lgpd: 'Texto de aceptación (privacidad)',
    ajudaLgpd: 'Con texto, el visitante marca la aceptación antes de conversar; el sistema guarda cuándo y qué texto aceptó.',
    ativo: 'Widget activo',
    inativo: 'Inactivo',
    novo: 'Nuevo widget',
    conversasAtivas: 'Conversaciones activas',
    codigo: 'Código para insertar',
    ajudaCodigo: 'Pégalo antes del </body> de las páginas del sitio. Si el sitio tiene política de seguridad de contenido (CSP), permite esta dirección en script-src y connect-src.',
    semEndereco: 'La dirección del Sandbox no está configurada en el servidor: el chat del Sandbox no abre en ningún sitio hasta configurarla.',
    salveParaCodigo: 'Guarda el widget para ver el código.',
    copiar: 'Copiar código',
    copiado: 'Código copiado',
    naoCopiado: 'No se pudo copiar; selecciona el código y cópialo.',
    vazioTitulo: 'Aún no hay chat del sitio',
    vazio: 'Crea un widget para cada sitio (o grupo de sitios) y pega el código en sus páginas. Las conversaciones llegan a la bandeja Sitio, en la cola elegida.',
    removerTitulo: '¿Eliminar este widget?',
    removerTexto: 'El chat desaparece de los sitios de inmediato. Las conversaciones que ya llegaron siguen en Conversaciones.',
  },
};

export const site = { pt, en, es };
